var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { FormContext } from "../../../common/context/context";
import Icons from '../../../icons';
import { LangHelper } from '../lang/helper';
import LangMessage from '../lang/message';
import { InputAndLabel, CustomInput, CustomLabel, RequiredAsterisk, CustomWrapperInput, ErrorSpan, ClearInput, ErrorMessage } from './input.styles';
export default function Input(props) {
    var label = props.label, htmlFor = props.htmlFor, type = props.type, id = props.id, name = props.name, placeholder = props.placeholder, required = props.required, value = props.value, errorMessage = props.errorMessage, autoComplete = props.autoComplete, onBlur = props.onBlur, errorMessageWithoutTrans = props.errorMessageWithoutTrans, className = props.className, handleClearInput = props.handleClearInput, inputWidth = props.inputWidth, widthFull = props.widthFull;
    var state = React.useContext(FormContext).state;
    var _a = React.useState(label), labelValue = _a[0], setLabelValue = _a[1];
    var _b = React.useState(placeholder), placeholderValue = _b[0], setPlaceholderValue = _b[1];
    useEffect(function () {
        if (label) {
            var translatedLabelValue = LangHelper.getLangMessageValue(label, state.lang);
            setLabelValue(translatedLabelValue);
        }
        var translatedPlaceholderValue = LangHelper.getLangMessageValue(placeholder, state.lang);
        setPlaceholderValue(translatedPlaceholderValue);
    }, [state]);
    var _c = useState(true), isValid = _c[0], setIsValid = _c[1];
    var _d = useState(false), isFocus = _d[0], setIsFocus = _d[1];
    var handleInputChange = function (e) {
        var _a;
        setIsValid(e.target.validity.valid);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
        setIsFocus(true);
    };
    var handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (isValid) {
                var inputs = document.querySelectorAll('input');
                var currentIndex = Array.from(inputs).indexOf(e.currentTarget);
                if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
                    var nextInput = inputs[currentIndex + 1];
                    nextInput.focus();
                }
            }
        }
    };
    var clearInputValue = function () {
        handleClearInput && handleClearInput();
    };
    return (_jsxs(InputAndLabel, __assign({ "$width": inputWidth, "$widthFull": widthFull }, { children: [label && (_jsxs(CustomLabel, __assign({ htmlFor: htmlFor }, { children: [labelValue, required && _jsx(RequiredAsterisk, { children: " *" })] }))), _jsxs(CustomWrapperInput, { children: [_jsx(CustomInput, { type: type, value: value, id: id, name: name, placeholder: placeholderValue || placeholder, required: required, onChange: handleInputChange, onKeyDown: handleKeyPress, onFocus: function () {
                            setIsFocus(true);
                        }, onBlur: onBlur, className: "".concat(isFocus ? 'focus' : '', " ").concat(errorMessage || errorMessageWithoutTrans || (!value && required) ? 'error' : '', " ").concat(className), autoComplete: autoComplete }), errorMessage && (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.length) > 0 && _jsx(ErrorSpan, {}), errorMessageWithoutTrans && (errorMessageWithoutTrans === null || errorMessageWithoutTrans === void 0 ? void 0 : errorMessageWithoutTrans.length) > 0 && _jsx(ErrorSpan, {}), isFocus && value && value.length > 0 && (_jsx(ClearInput, { src: Icons.clear, alt: 'clear', onClick: clearInputValue }))] }), errorMessage && _jsx(ErrorMessage, { children: _jsx(LangMessage, { msgKey: errorMessage }) }), errorMessageWithoutTrans && _jsx(ErrorMessage, { children: errorMessageWithoutTrans })] })));
}
